export default {
  FETCH_VISA_ASSISTANCE_DATA: "FETCH_VISA_ASSISTANCE_DATA",
  FETCH_VISA_ASSISTANCE_DATA_SUCCESS: "FETCH_VISA_ASSISTANCE_DATA_SUCCESS",
  FETCH_VISA_ASSISTANCE_DATA_ERROR: "FETCH_VISA_ASSISTANCE_DATA_ERROR",
};
